<script defer>
  /**Dependencies*/
  import { onMount, afterUpdate } from "svelte";
  import { browser } from "$app/environment";
  import { page } from "$app/stores";
  import { addEventListeners, ANALYTICS_CONSENT, dispatchCustomEvent } from "$lib/utils/events";
  import { navigating } from "$app/stores";
  import { beforeNavigate, goto } from "$app/navigation";
  import { klaviyoIdentify } from "$lib/utils/KlaviyoEvents";

  /**Server side rendering*/
  import { customer } from "$lib/state/customer";
  import { cart } from "$lib/state/cart";
  import { cartTotals } from "$lib/state/cartTotals";
  import schema from "./schema.json";

  /**Loading component*/
  import { loading } from "$lib/components/layout/loading";
  import Loading from "$lib/components/layout/Loading.svelte";

  /**Components*/
  import FreeShippingBanner from "$lib/components/cart/FreeShippingBanner.svelte";
  import Footer from "$lib/components/layout/Footer.svelte";
  import Header from "$lib/components/layout/header/Header.svelte";
  import Analytics from "$lib/utils/Analytics.svelte";
  import SalePageFloating from "$lib/components/layout/SalePageFloating.svelte";
  import GoogleTagManager from "$lib/utils/GoogleTagManager.svelte";
  import Notify from "$lib/components/layout/Notify.svelte";

  /**@type {import('./$types').LayoutData}*/
  export let data;

  customer.set(data.customerInfo);
  cart.set(data.cartInfo);
  cartTotals.set(data.cartTotals);

  $: loading.setNavigate(!!$navigating);


  /**@type {boolean}*/
  let isPrivacyLoading = false;
  /**@type {HTMLDialogElement}*/
  let proposal;
  /**@param {boolean}isPrivacy*/
  function setPrivacy(isPrivacy) {
    if (isPrivacy) {
      proposal?.close();
      document.cookie = `privacy-proposal = true; expires = ${new Date().getUTCDate()}; path=/`;
      isPrivacyLoading = true;
      dispatchCustomEvent(ANALYTICS_CONSENT, 'granted')
    } else {
      proposal?.close();
      document.cookie = `privacy-proposal = false; expires = ${new Date().getUTCDate()}; path=/`;
      isPrivacyLoading = false;
      dispatchCustomEvent(ANALYTICS_CONSENT, 'denied')
    }
  }

  onMount(() => {
    // dispatchCustomEvent(ANALYTICS_CONSENT, "granted");
    if (!data.privacy) {
      proposal?.showModal();
    }
    if (data.privacy == "false") {
      isPrivacyLoading = false;
    } else {
      isPrivacyLoading = true;
    }
  });

  afterUpdate(() => {
    addEventListeners();
  });

  //traking urls from mailchimp or klaviyo
  beforeNavigate(({ from, to, cancel }) => {
    if (from?.url.searchParams.has("utm_source") && !to?.url.searchParams.has("utm_source")) {
      if (
        to?.url.pathname !== "/" &&
        to?.url.pathname !== "/cart/checkout/complete-purchase" &&
        to?.url.pathname !== "/search/results"
      ) {
        cancel();
        goto(to?.url.pathname + `${from?.url.search}`);
      }
    }
  });

  $: {
    customer;
    if ($customer) {
      afterUpdate(() => {
        klaviyoIdentify($customer);
      });
    }
  }
</script>

<svelte:head>
  {#if browser}
    <title>{$page.data.title || "Gelish & Morgan Taylor"}</title>
    <meta name="nailalliance-version" content="NAIL_ALLIANCE_VERSION_NUMBER">
    <meta property="og:title" content="Gelish & Morgan Taylor" />
    <script
      async
      defer
      src="https://www.recaptcha.net/recaptcha/api.js?render=6Lei0pobAAAAAKC5zB-TGn72-zt5IohwP3S3pCJe"
    >
    </script>
    <!-- Meta Tags only gelish.com -->
    {#if $page.url.hostname == "gelish.com"}
      <!--Schema Script-->
      {@html `<script type="application/ld+json">${JSON.stringify(schema)}</script>`}
      <!--END Schema Script-->

      <script async defer type="text/javascript">
        var MTIProjectId = "fe54ecbc-b54d-48f5-bb1f-bffc03f32b1e";
        document?.addEventListener(
          "load",
          (() => {
            var mtiTracking = document.createElement("script");
            mtiTracking.type = "text/javascript";
            mtiTracking.async = "true";
            mtiTracking.src = "/fonts/mtiFontTrackingCode.js";
            document.getElementsByTagName("head")[0].appendChild(mtiTracking);
          })(),
          false
        );
      </script>
      <!-- Start Open Web Analytics Tracker -->
      <script async defer type="text/javascript">
        //<![CDATA[
        var owa_baseUrl = "https://analytics.nailharmony.net/";
        var owa_cmds = owa_cmds || [];
        owa_cmds.push(["setSiteId", "bdd1d1b18e9a0bbe71431074d259c35e"]);
        owa_cmds.push(["trackPageView"]);
        owa_cmds.push(["trackClicks"]);

        (function () {
          var _owa = document.createElement("script");
          _owa.type = "text/javascript";
          _owa.async = true;
          owa_baseUrl =
            "https:" == document.location.protocol
              ? window.owa_baseSecUrl || owa_baseUrl.replace(/http:/, "https:")
              : owa_baseUrl;
          _owa.src = owa_baseUrl + "modules/base/js/owa.tracker-combined-min.js";
          var _owa_s = document.getElementsByTagName("script")[0];
          _owa_s.parentNode.insertBefore(_owa, _owa_s);
        })();
        //]]>
      </script>
      <!-- End Open Web Analytics Code -->
    {/if}
    <!-- KLAVIYO -->
    <script
      type="text/javascript"
      async
      src="https://static.klaviyo.com/onsite/js/W88RTW/klaviyo.js"
    ></script>
    <!-- <script type="text/javascript">
      !(function () {
        if (!window.klaviyo) {
          window._klOnsite = window._klOnsite || [];
          try {
            window.klaviyo = new Proxy(
              {},
              {
                get: function (n, i) {
                  return "push" === i
                    ? function () {
                        var n;
                        (n = window._klOnsite).push.apply(n, arguments);
                      }
                    : function () {
                        for (var n = arguments.length, o = new Array(n), w = 0; w < n; w++)
                          o[w] = arguments[w];
                        var t = "function" == typeof o[o.length - 1] ? o.pop() : void 0,
                          e = new Promise(function (n) {
                            window._klOnsite.push(
                              [i].concat(o, [
                                function (i) {
                                  t && t(i), n(i);
                                },
                              ])
                            );
                          });
                        return e;
                      };
                },
              }
            );
          } catch (n) {
            (window.klaviyo = window.klaviyo || []),
              (window.klaviyo.push = function () {
                var n;
                (n = window._klOnsite).push.apply(n, arguments);
              });
          }
        }
      })();
    </script> -->
  {/if}
</svelte:head>

{#if isPrivacyLoading}
  <Analytics />
  <GoogleTagManager />
{/if}
<span class="label" id="button">Action button</span>
<span class="label" id="close">Close button</span>

<FreeShippingBanner />
<Header />
<main>
  <slot />
</main>
<Notify />
<SalePageFloating />
<!-- Privacy proposal -->
<dialog bind:this={proposal} class="proposal" hidden={data?.privacy === "true"}>
  <div class="privacy-proposal">
    <div class="text">
      <h3>Privacy Policy</h3>
      <p>
        We use cookies for our Google Analytics, Facebook likes, and to keep an anonymized session.
        You can find out more on our privacy policy here.
        <a href="/privacy" aria-labelledby="privacy">Privacy Policy.</a>
        <span id="privacy" class="label">Go to Privacy Policy</span>
      </p>
    </div>
    <div class="butons">
      <button
        class="no-thanks"
        aria-labelledby="no-thanks"
        on:click={() => setPrivacy(false)}
        aria-label="Reject All"
      >
        <span id="no-thanks" class="label">Reject All</span>
        Reject All
      </button>
      <button
        class="yes-thanks"
        aria-labelledby="yes-thanks"
        on:click={() => setPrivacy(true)}
        aria-label="Allow All"
      >
        <span id="yes-thanks" class="label">Allow All</span>
        Allow All
      </button>
    </div>
  </div>
</dialog>
<Footer />
{#if !$page.url.pathname.includes("/colors")}
  <Loading />
{/if}

<style>
  dialog {
    border-radius: 20px 0 0 20px;
    padding: 20px;
    max-width: 420px;
    top: auto;
    left: auto;
    overflow: hidden;
  }

  .privacy-proposal {
    display: flex;
    flex-direction: column;
    gap: 20px;
    transform: translateX(0);
    transition: all 0.6s ease;
  }
  .text {
    letter-spacing: 0px;
    font-family: "gotham-bold";
  }
  .text h3 {
    font-size: 1.125em;
    text-align: center;
    padding-bottom: 10px;
  }
  .text p {
    font-size: 0.875em;
    text-align: left;
    line-height: 1.5;
    font-family: "gotham-book";
  }
  .text a {
    text-decoration: none;
    color: #000;
    font-weight: 500;
    font-family: "gotham-book";
  }
  .butons {
    display: grid;
    grid-template-columns: 50% 50%;
    gap: 5px;
    font-family: "gotham-bold";
    letter-spacing: 0px;
  }
  .no-thanks,
  .yes-thanks {
    border: none;
    padding: 10px 0;
    border-radius: 5px;
    cursor: pointer;
    min-width: 120px;
    text-align: center;
    transition: all 0.5s ease;
  }
  .no-thanks {
    border: 1px solid var(--secondary-color);
    color: var(--secondary-color);
    background-color: var(--primary-color);
    font-size: 0.875em;
    letter-spacing: 1.2px;
  }
  .yes-thanks {
    border: 1px solid var(--secondary-color);
    background-color: var(--secondary-color);
    font-size: 0.875em;
    letter-spacing: 1.2px;
    color: var(--primary-color);
  }
</style>
